/** Game modes and the map each one is played on. */
export enum GameMode {
  /** King of the Hill: hold the point to fill your percentage. */
  Control = 0,
  /** Escort: the attackers push the payload down the track; sides swap for round two. */
  Convoy = 1,
}

export type MapId = "foundry" | "brussels" | "switchyard" | "orlando";

export interface MapInfo {
  id: MapId;
  title: string;
  mode: GameMode;
  /** One line for the lobby's map picker. */
  blurb: string;
  /** Convoy: the attack clock a round starts on (s), as the map's TRACK_00 sets it. */
  attackSeconds?: number;
  /** Control: the names of the map's stages (sub-maps), by stage; one round is played on each. */
  stages?: string[];
}

export const MAPS: Record<MapId, MapInfo> = {
  foundry: { id: "foundry", title: "The Foundry", mode: GameMode.Control, blurb: "A steel hall with one point in the middle." },
  brussels: { id: "brussels", title: "Brussels", mode: GameMode.Convoy, blurb: "Run the tram from the Bourse, across the Grand-Place and up the Mont des Arts to the Palais de Justice.", attackSeconds: 150 },
  switchyard: { id: "switchyard", title: "Switchyard", mode: GameMode.Convoy, blurb: "A greybox rail yard.", attackSeconds: 300 },
  orlando: {
    id: "orlando",
    title: "Orlando",
    mode: GameMode.Control,
    blurb: "Three stages, one round on each: the band shell at Lake Eola, under the Wheel on International Drive, and the gator's jaws on the Orange Blossom Trail.",
    stages: ["Lake Eola", "International Drive", "Orange Blossom Trail"],
  },
};

export const MODES: Record<GameMode, { name: string; map: MapId; blurb: string }> = {
  [GameMode.Control]: { name: "Control", map: "orlando", blurb: "Hold the point to fill your percentage. Best of three." },
  [GameMode.Convoy]: { name: "Convoy", map: "brussels", blurb: "Escort the payload, then stop theirs. Push further to win." },
};

export const isGameMode = (m: unknown): m is GameMode => m === GameMode.Control || m === GameMode.Convoy;
export const isMapId = (m: unknown): m is MapId => typeof m === "string" && Object.hasOwn(MAPS, m);
/** A mode's default map. */
export const mapFor = (mode: GameMode): MapInfo => MAPS[MODES[mode].map];
export const mapUrl = (id: MapId) => `/assets/maps/${id}.glb`;
